import { Record, List } from 'immutable';
import { Utils } from '@kineticdata/bundle-common';
const { noPayload, withPayload } = Utils;
const ns = Utils.namespaceBuilder('services/externalOfferings');

export const types = {
  FETCH_EXTERNAL_OFFERINGS_REQUEST: ns('FETCH_EXTERNAL_OFFERINGS_REQUEST'),
  FETCH_EXTERNAL_OFFERINGS_SUCCESS: ns('FETCH_EXTERNAL_OFFERINGS_SUCCESS'),
  FETCH_EXTERNAL_OFFERINGS_FAILURE: ns('FETCH_EXTERNAL_OFFERINGS_FAILURE'),
};

export const actions = {
  fetchExternalOfferingsRequest: noPayload(
    types.FETCH_EXTERNAL_OFFERINGS_REQUEST,
  ),
  fetchExternalOfferingsSuccess: withPayload(
    types.FETCH_EXTERNAL_OFFERINGS_SUCCESS,
  ),
  fetchExternalOfferingsFailure: withPayload(
    types.FETCH_EXTERNAL_OFFERINGS_FAILURE,
  ),
};

export const State = Record({
  data: List(),
  error: null,
});

const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_EXTERNAL_OFFERINGS_REQUEST:
      return state.set('error', null);
    case types.FETCH_EXTERNAL_OFFERINGS_SUCCESS:
      return state.set('data', List(payload));
    case types.FETCH_EXTERNAL_OFFERINGS_FAILURE:
      return state.set('error', payload);

    default:
      return state;
  }
};

export default reducer;
